import createSvgIcon from "./utils/create_icon"

const ArrowRight = createSvgIcon(<path d="M13.293 14.293a1 1 0 0 0 1.414 1.414l3-3a1 1 0 0 0 0-1.414l-3-3a1 1 0 1 0-1.414 1.414L14.586 11H7a1 1 0 1 0 0 2h7.586z" fill="currentColor" />, "ArrowRight")
export default ArrowRight
